export default "__VITE_ASSET__afa022d0__"